import { render } from "./VuetableColGutter.vue?vue&type=template&id=7b2cbb88"
import script from "./VuetableColGutter.vue?vue&type=script&lang=js"
export * from "./VuetableColGutter.vue?vue&type=script&lang=js"

import "./VuetableColGutter.vue?vue&type=style&index=0&id=7b2cbb88&lang=css"

import exportComponent from "D:\\www\\Centroid\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__